module.exports = __webpack_public_path__ + "img/chatJangKyungProfile.62fa921.png";